import type { Location } from "@/graphql/codegen/graphql"
import {
  ProductOrigin,
  type ProductOriginFormType,
  type ProductOriginSubmissionType,
} from "@/screens/Products/components/Product/Information/types/productOrigin"

export function transformProductOriginSubmitData(
  productOrigin: ProductOriginFormType | null
): ProductOriginSubmissionType {
  const shouldClearLocation = productOrigin?.originType === ProductOrigin.SUPPLIER && !productOrigin?.exactLocation
  const shouldCleaExactLocation =
    productOrigin?.originType === ProductOrigin.OTHER &&
    (productOrigin?.country || productOrigin?.region?.id || productOrigin?.city)

  return {
    exactLocationId: shouldClearLocation || shouldCleaExactLocation ? null : productOrigin?.exactLocation || null,
    regionIsoCode: shouldClearLocation ? null : productOrigin?.region?.id || null,
    city: shouldClearLocation ? null : productOrigin?.city || null,
    countryIsoCode: shouldClearLocation ? null : productOrigin?.country || null,
  }
}

export function getOriginTypeValue(
  origin: Pick<ProductOriginFormType, "exactLocation"> | null | undefined,
  companyManufacturingOriginLocations: Location[]
): ProductOrigin | null {
  const hasSupplierLocation = companyManufacturingOriginLocations.find((el) => origin?.exactLocation === el.locationId)
  const hasOtherLocation = !origin?.exactLocation

  if (hasSupplierLocation) {
    return ProductOrigin.SUPPLIER
  }

  if (hasOtherLocation) {
    return ProductOrigin.OTHER
  }

  return null
}
